import { render, staticRenderFns } from "./ShippmentTimeline.vue?vue&type=template&id=c1d5ac16&scoped=true"
import script from "./ShippmentTimeline.vue?vue&type=script&lang=js"
export * from "./ShippmentTimeline.vue?vue&type=script&lang=js"
import style0 from "./ShippmentTimeline.vue?vue&type=style&index=0&id=c1d5ac16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d5ac16",
  null
  
)

export default component.exports